module.exports = __webpack_public_path__ + "img/postagram_phone_x.1b58e592.png";